import { Button, Input } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import { dicStayAreaStatusOptions } from "../config";
import type { DicStayAreaListFilters } from "../types";
import "../../../shared/ui/crmListPageLayout.css";
import "./DicStayAreaPage.css";

type DicStayAreaFilterPanelProps = {
  filters: DicStayAreaListFilters;
  errorMessage: string;
  onChange: (filters: DicStayAreaListFilters) => void;
  onReset: () => void;
  onSearch: () => void;
};

/** 住宿点筛选区。 */
export function DicStayAreaFilterPanel({
  filters,
  errorMessage,
  onChange,
  onReset,
  onSearch,
}: DicStayAreaFilterPanelProps) {
  return (
    <section
      className="crm-list-filter-panel"
      role="search"
      aria-label="住宿点筛选"
      data-layout="two-tier-responsive"
    >
      <div className="crm-list-filter-fields">
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>关键词</span>
            <Input
              placeholder="省、市、住宿点名称或拼音码"
              value={filters.keyword ?? ""}
              onChange={(keyword) => onChange({ ...filters, keyword })}
            />
          </label>
          <label className="crm-list-field crm-list-field--md">
            <span>省份</span>
            <Input
              placeholder="请输入省份"
              value={filters.province ?? ""}
              onChange={(province) => onChange({ ...filters, province })}
            />
          </label>
          <label className="crm-list-field crm-list-field--md">
            <span>城市</span>
            <Input
              placeholder="请输入城市"
              value={filters.city ?? ""}
              onChange={(city) => onChange({ ...filters, city })}
            />
          </label>
          <label className="crm-list-field crm-list-field--sm">
            <span>状态</span>
            <select
              className="dic-stay-area-native-select"
              data-testid="stay-area-status-select"
              aria-label="状态"
              value={filters.isDisabled === undefined ? "" : String(filters.isDisabled)}
              onChange={(event) =>
                onChange({
                  ...filters,
                  isDisabled:
                    event.target.value === "" ? undefined : event.target.value === "true",
                })
              }
            >
              {dicStayAreaStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        {errorMessage ? <div className="dic-stay-area-error">{errorMessage}</div> : null}
      </div>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          搜索
        </Button>
      </div>
    </section>
  );
}
